import state from '@/vuex/relatorios/state.js'
import getters from '@/vuex/relatorios/getters.js'
import mutations from '@/vuex/relatorios/mutations.js'
import actions from '@/vuex/relatorios/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
